import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

import BusinessApp from './components/business/BusinessApp';
import ClientApp from './components/client/ClientApp';
import Login from './components/Login';

@inject('userStore')
@withRouter
@observer
class App extends Component {
  render() {
      if (this.props.userStore.token !== '') {
          if (this.props.userStore.role_list.length > 0){
              if (this.props.userStore.role_list.includes('Business')){
                  return (
                      <BusinessApp/>
                  );
              } else if (this.props.userStore.role_list.includes('Client')) {
                  return (
                      <ClientApp/>
                  );
              }
          }
      }
      return (
          <Login />
      );

  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js